export default __webpack_public_path__ + "static/media/work-mob-searc.53f0636d.png";